import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useHistory} from 'react-router-dom';

import axios from "axios";

import Scene from "./ThreeScene";
import FramebusListener from "./FramebusListener";
import HoverApp from "./Components/HoverApp";
import BasicScene from "./Components/BasicScene";
import ApartmentMenu from "./Components/ApartmentMenu/ApartmentMenu";
import { loadModelGLTF } from "./utils/loadingManager";
import Rectangle from "./Components/UI/Rectangle";
import ApartmentDetails from "./Components/AppartmentDetails";
import { MeshBasicMaterial } from "three";
import { setLang } from "./i18n";

export function AppData({}) {
  const [saveStatus, setSaveStatus] = useState("Save");
  const [viewedApartment, setviewedApartment] = useState();
  const [touredApartment, setTouredApartment] = useState();
  const [hoveredApartment, setHoveredApartment] = useState();
  const [show3dMap, setShow3dMap] = useState(false);
  const [building, setBuilding] = useState();
  const [apartment, setApartment] = useState();
  const [cameraPosition, setCameraPosition] = useState();
  const [mousePosition, setMousePosition] = useState();
  const [appId, setAppId] = useState();
  const [loadedModels, setLoadedModels] = useState();

  const [basicModels, setBasicModels] = useState();
  const [frameBusMessaage, setFrameBusMessaage] = useState();
  const [floor, setFloor] = useState();
  // const [settings, setSettings] = useState()
  const [newProjectLoaded, setNewProjectLoaded] = useState(false);

  // const models = useRef([])
  const wrapperRef = useRef();
  const settings = useRef();
  const sceneRef = useRef();

  useEffect(() => {
    if (wrapperRef.current) {
      // console.log("setFrameBusMessaage")
      setFrameBusMessaage({ action: "3dAppReady" });
    }

    return () => {};
  }, []);

  const getProjectData = (products) => {
    const apartments = Object.keys(products)
      .filter((key) => products[key].type_building)
      .map((productId) => products[productId]);
    // console.log("App data products", products)
    return {
      apartments,
      // modelUrl,
      // hdrUrl
    };
  };
  async function loadModels() {
    console.log("INITIAL LOADING MODELS", settings.current);
  
    const buildingsModels = {};
    const basicModels = {};
    const projectModels = {};
    const apartmentNodes = [];
    // Use Promise.all to handle all asynchronous operations
    const loadModelPromises = settings.current.buildings.map(async (building, index) => {
  
      if (building["3d_model_file"]) {
        try {
          const model = await loadModelGLTF(building["3d_model_file"]);
          console.log("building_model", index);
  
          model.traverse((node) => {
            if (node.name.includes("bbox")) {
              const app = settings.current.apartments.find((app) =>
                app.title
                  ? app.title === node.name.split("_")[0] || app.title === node.name.split("_")[1]
                  : app.name === node.name.split("_")[0] || app.name === node.name.split("_")[1]
              );
  
              if (app) {
                node.userData = { apartment: app };
                apartmentNodes.push(node);
                if (node.children.length > 10) {
                  node.children.forEach((child) => {
                    if (!child.name.includes("walls") && !child.name.includes("celling_30")) {
                      child.visible = false;
                    }
                  });
                }
              }
            }
          });
  
          buildingsModels[building.id] = model;
          basicModels[building.id] = model.clone(true);
        } catch (error) {
          console.log("An error happened while loading the model:", error);
        }
      }
    });
    const loadProjectModelPromises = settings.current.projectModels.map(async (projModel, index) => {

      if (projModel.url) {
        try {
          const model = await loadModelGLTF(projModel.url);

          projectModels[projModel.id] = model;
        } catch (error) {
          console.log("An error happened while loading the model:", error);
        }
      }
    });
    

  
    // Wait for all models to load
    await Promise.all([...loadModelPromises, ...loadProjectModelPromises]);
  
    // console.log("All models loaded");
    return { buildingsModels, projectModels, basicModels, apartmentNodes };
  }
  const handleMoveApartmentModel = (apartment, source = "unknown") => {
    console.log(`[FloorView] handleMoveApartmentModel called from "${source}"`, {
      apartmentId: apartment && apartment.id,
      apartmentTitle: apartment && (apartment.title || apartment.name),
      floorId: apartment && apartment.floor_id,
      floorNumber: apartment && apartment.floor_number,
    });
    setTouredApartment((prev) => {
      if (prev && prev.id === apartment.id) {
        console.log("[FloorView] toggling touredApartment off", apartment.id);
        return null;
      } else {
        return apartment;
      }
    });
  };

  const handleMessage = (message, reply) => {
    // console.log("handleMessage", message)

    switch (message.action) {
      case "show-apartment":
      case "open apartment":
        // console.log({settings})
        // console.log("show-apartment", message)
        // console.log(settings.current.apartments)
        const selectedApp = settings.current.apartments.find(
          (app) => app.id && message.apartment && app.id === message.apartment.id
        );
        console.log("selectedApp", selectedApp)
        selectedApp && setviewedApartment(selectedApp);
        break;
      // case "i-am-admin":
      //   if (message.token) setToken(message.token)
      //   break
      case "hover-apartment":
        // Everything downstream (ThreeScene's highlight effect, ApartmentDetails)
        // expects the full apartment object, not just its id — storing the id
        // here made `hoveredApartment.id` resolve to undefined, so a hover from
        // the olyo-ai unit list never matched a mesh and never highlighted.
        setHoveredApartment(message.apartment || null);
        break;
      case "show-building":
        setBuilding(message.building);
        break;
      case "show-apartment-floor":
        console.log("show-apartment-floor", message);
        if (message.apartment) {
          const floorNumber = message.apartment.floor_number;
          const buildingName = message.apartment.type_building && message.apartment.type_building.name;
          if (floorNumber === undefined || floorNumber === null || !buildingName) {
            console.error(
              "[FloorView] show-apartment-floor: apartment has malformed floor data — missing floor_number or type_building.name",
              {
                apartmentId: message.apartment.id,
                floor_number: floorNumber,
                type_building: message.apartment.type_building,
              }
            );
          }
          setFloor({
            name: floorNumber,
            building: buildingName,
          });
        }
        else setFloor(null);
        break;
      case "move-apartment-model":
        console.log("move-apartment-model", message);
        if (message.apartment) handleMoveApartmentModel(message.apartment, "framebus:move-apartment-model");

        break;
      case "show3dMap":
        setShow3dMap(true);
        break;
      case "set-camera-view":
        console.log("set-camera-view", message);
        setCameraPosition(message.view.viewData);
        break;
      case "takeSnapshot":
        if (sceneRef.current) {
          const snapshot = sceneRef.current.takeSnapshot();
          setFrameBusMessaage({ action: "snapshotTaken", data: snapshot });
        }
        break;
      case "newProjectLoaded":
        console.log("newProjectLoaded", message);
        
        if (settings.current) return;
        setLang(message.params && message.params.fp_lang);
        let projectSettings = getProjectData(message.products);
        // console.log("projectSettings", projectSettings);
        // setIsRtl(message.params.fp_lang == 'he' ? true : false)
        settings.current = {
          ...projectSettings,
          statuses: message.statuses,
          buildings: message.buildings,
          projectModels: message.models,
          floors: message.floors,
          tileSetUrl: message.tiles ? message.tiles.url : undefined,
          projectImages: message.projectImages,
          colors: message.colors,
          apartmentBlockFieldsOrder: message.apartmentBlockFieldsOrder,
          projectId: message.projectId,
          projectDefaultView: message.projectDefaultView,
          isRtl: message.params.fp_lang === "he" ? true : false,
          hdrUrl: message.hdrUrl,
          // skyImage: message.skyImage,
          isAdmin: message.isAdmin,
          // isAdmin: true,
        };
        console.log("settings.current", settings.current);
        if (message.buildings && message.buildings.length > 0 && !loadedModels) {
          // console.log("message.buildings", message.buildings.length);
          loadModels().then((result) => {
            console.log("models loaded", result);
            setLoadedModels(result);
            setNewProjectLoaded(true);
            setFrameBusMessaage({ action: "modelReady", data: true });
          });
        }

        // setNewProjectLoaded(true)
        // fetchData(message.projectId, message.params)
        break;
      default:
        break;
    }
  };
  const saveApartmentViewData = async (viewData) => {

    setFrameBusMessaage({
      action: "updateDataFieldPerType",
      data: {
        value: viewData,
        id: viewedApartment.id,
        field: "default_view",
        type: "apartment",
      },
    });
  };
  const saveModelCalibration = async (calibration, modelId, type) => {

    setFrameBusMessaage({
      action: "updateDataFieldPerType",
      data: {
        value: calibration,
        id: modelId,
        field: "default_view",
        type: type,
      },
    });
  };

  const saveProjectSettings = async (newSettings) => {

    setFrameBusMessaage({
      action: "updateDataFieldPerType",
      data: {
        value: newSettings,
        id: settings.current.projectId,
        field: "default_view",
        type: "project",
      },
    });

  };
  const onBackButtonClick = () => {
    console.log("onBackButtonClick");
    setAppId(null);
    setTouredApartment(null);
  };
  const onApartmentHover = (app, position) => {
    // console.log(app, position)
    setApartment(app);
  };

  const scene = useMemo(() => {
    if (settings.current && loadedModels && newProjectLoaded)
      return (
        <Scene
          ref={sceneRef}
          {...settings.current}
          loadedModels={loadedModels}
          show3dMap={show3dMap}
          viewedApartment={viewedApartment}
          hoveredApartment={hoveredApartment}
          touredApartment={touredApartment}
          onApartmentHover={onApartmentHover}
          setMousePosition={(position) => setMousePosition(position)}
          // onApartmentClick={app => setTouredApartment(app)}
          onApartmentClick={(app) => {
            console.log("onApartmentClick", app);
            // A NEW object on every click (and the apartment's UNIQUE id), so
            // FramebusListener's [appId] effect fires even when the same
            // apartment is clicked again — with a plain string, re-clicking a
            // unit after picking another one in the host list sent nothing.
            setAppId({ id: app.id ?? app.title, title: app.title })
            setHoveredApartment(app);
          }}
          saveApartmentViewData={saveApartmentViewData}
          saveProjectSettings={saveProjectSettings}
          floor={floor}
          saveModelCalibration={saveModelCalibration}
          cameraPosition={cameraPosition}
          saveStatus={saveStatus}
          selectedBuildingName={building}
          setSelectedBuildingName={(buildingName) => setBuilding(buildingName)}
          setModelReady={(completed) => {
            // setFrameBusMessaage({ action: "modelReady", data: completed })

          }
          }
          onAnimationEnd={() => setFrameBusMessaage({ action: "animationEnd" })}
          onBuildingSelect={(buildingId) => setFrameBusMessaage({ action: "onBuildingSelect", data: buildingId })}
          onBackButtonClick={onBackButtonClick}
        />
      );
  }, [
    viewedApartment,
    hoveredApartment,
    touredApartment,
    building,
    newProjectLoaded,
    saveStatus,
    floor,
    cameraPosition,
    loadedModels,
  ]);
  // if (modelUrl && !isLoading) {

  return (
    <div ref={wrapperRef}>
            <FramebusListener
        onMessage={(message, reply) => handleMessage(message, reply)}
        appId={appId}
        message={frameBusMessaage}
      />
      {/* {frameBus} */}
      {scene}
      {window.innerWidth < 700 && hoveredApartment && settings.current && <ApartmentDetails apartment={hoveredApartment} apartmentBlockFieldsOrder={settings.current.apartmentBlockFieldsOrder} />}
      {/* <ApartmentMenu /> */}
      {window.innerWidth > 500 && <div
        style={{
          position: "absolute",
          bottom: 0,
          left: touredApartment ? "0" : "-250px",
          width: "280px",
          height: "200px",
          // background: "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 20, 1) 100%)",
          opacity: touredApartment ? 1 : 0,
          transition: "all 0.5s",
          zIndex: "10",
        }}
      >
        <Rectangle
          width={"280px"}
          height={"200px"}
          topLeft={{ x: 0, y: 0 }}
          topRight={{ x: 100, y: 0 }}
          bottomLeft={{ x: 0, y: 100 }}
          bottomRight={{ x: 70, y: 100 }}
          background="linear-gradient(180deg, rgb(70, 70, 70) 0%, rgba(25, 25, 25, 1) 40%)"
        >
          <div
            className="topRightButton"
            style={{
              position: "absolute",
              top: 0,
              right: -3,
              width: "auto",
              height: "30px",
              // background: 'rgba(0, 0, 0, 0.5)',
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            <Rectangle
              className={
                "d-flex align-items-center justify-content-center cursor-pointer"
              }
              width={"120px"}
              height={"40px"}
              topLeft={{ x: 16.2, y: 0 }}
              topRight={{ x: 100, y: 0 }}
              bottomLeft={{ x: 0, y: 100 }}
              bottomRight={{ x: 85, y: 100 }}
              background={
                settings.current ? settings.current.colors.primary : "#3D3D3D"
              } // Change background on hover
            >
              <div onClick={() => setFrameBusMessaage({ action: "goToApartmentPage", data: touredApartment })}>
                Enter
              </div>
            </Rectangle>
          </div>
          <div
            id="threejs-canvas-left"
            style={{
              width: "200px",
              height: "100%",
            }}
          >
            {basicModels && (
              <BasicScene
                elementId="threejs-canvas-left"
                touredApartment={touredApartment}
                models={basicModels}
                newProjectLoaded={newProjectLoaded}
                {...settings.current}
     
              />
            )}
          </div>
        </Rectangle>
      </div>
}
      {/* {window.innerWidth > 500 && <div
        style={{
          position: "absolute",
          bottom: 0,
          right: touredApartment ? "0" : "-300px",
          width: "300px",
          height: "200px",
          opacity: touredApartment ? 1 : 0,
          transition: "all 0.5s",
          zIndex: "10",
        }}
      >
        <Rectangle
          width={"300px"}
          height={"200px"}
          topLeft={{ x: 30, y: 0 }}
          topRight={{ x: 100, y: 0 }}
          bottomLeft={{ x: 0, y: 100 }}
          bottomRight={{ x: 100, y: 100 }}
          background="linear-gradient(180deg, rgba(25, 25, 25, 0.5) 0%, rgba(15, 15, 15, 1) 80%)"
        >
          <div
            id="threejs-canvas-right"
            style={{
              position: "absolute",
              right: 0,
              width: "210px",
              height: "100%",
            }}
          ></div>
        </Rectangle>
      </div>
      } */}
      {window.innerWidth > 500 && mousePosition && settings.current && (
        <HoverApp
          {...settings.current}
          apartment={apartment}
          mousePosition={mousePosition}
          goToApartmentPage={(appId) =>
            setFrameBusMessaage({ action: "goToApartmentPage", data: appId })
          }
          onFloorView={(app) => handleMoveApartmentModel(app, "floor-view-button")}
        />
      )}
    </div>
  );

  // }
  // else return (
  //   <div>Loading</div>
  // )
}

export default AppData;
